import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import cx from 'classnames2';
import React from 'react';
import { Input, ValidationStates } from '../Input';
import { InputGroup } from '../InputGroup';
import styles from './ColorInput.scss';
export var ColorInput = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorInput, _React$Component);

  var _super = _createSuper(ColorInput);

  function ColorInput() {
    var _this;

    _classCallCheck(this, ColorInput);

    _this = _super.apply(this, arguments);

    _this.cleanInputString = function (value) {
      // Strip hash sign if present
      if (value && value.match(/#/g) && value.match(/#/g).length) {
        return value.replace('#', '');
      }

      return value;
    };

    _this.handleChange = function (value) {
      _this.props.onChange("#".concat(value));
    };

    return _this;
  }

  _createClass(ColorInput, [{
    key: "render",
    value: function render() {
      var _cx, _cx2, _cx3, _cx4;

      var hasError = this.props.validationState === ValidationStates.Error;
      var isSmall = this.props.size === 'small';
      var isDefault = this.props.size === 'default';
      var inputStyles = cx((_cx = {}, _defineProperty(_cx, styles.inputDefault, isDefault), _defineProperty(_cx, styles.inputSmall, isSmall), _defineProperty(_cx, styles.inputError, hasError), _cx));
      var hexPrefixStyles = cx(styles.hexPrefix, (_cx2 = {}, _defineProperty(_cx2, styles.hexPrefixDefault, isDefault), _defineProperty(_cx2, styles.hexPrefixSmall, isSmall), _cx2));
      var colorSwatchWrapperStyles = cx((_cx3 = {}, _defineProperty(_cx3, styles.colorSwatchWrapperDefault, isDefault), _defineProperty(_cx3, styles.colorSwatchWrapperSmall, isSmall), _cx3));
      var colorSwatchStyles = cx((_cx4 = {}, _defineProperty(_cx4, styles.colorSwatchDefault, isDefault), _defineProperty(_cx4, styles.colorSwatchSmall, isSmall), _cx4));
      return React.createElement("div", {
        className: cx(styles.container, styles.error)
      }, React.createElement("div", {
        className: hexPrefixStyles
      }, "#"), React.createElement(InputGroup, null, React.createElement(Input.Text, {
        dataTest: "color-input",
        size: this.props.size,
        value: this.cleanInputString(this.props.color),
        onChange: this.handleChange,
        onBlur: this.props.onBlur,
        inputClassName: inputStyles,
        maxLength: 6,
        placeholder: 'FFFFFF'
      }), React.createElement(InputGroup.Suffix, {
        size: this.props.size
      }, hasError ? React.createElement(InputGroup.Icon, {
        icon: "status-error",
        dataTest: "error-icon"
      }) : React.createElement("div", {
        className: colorSwatchWrapperStyles
      }, React.createElement("div", {
        key: this.props.color,
        "data-test": "color-input-swatch",
        className: colorSwatchStyles,
        style: {
          backgroundColor: this.props.color || 'FFFFFF'
        }
      })))));
    }
  }]);

  return ColorInput;
}(React.Component);
ColorInput.defaultProps = {
  size: 'default',
  onChange: function onChange() {}
};